import type { DtActionsAtom } from '@/components/pages/backoffice/_klb-penyuluh/_kecamatan/state/atoms'
import type {
  ServiceGetAllResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { PenyuluhListDataType } from './types'

const QUERY_KEY = (key?: string | Record<string, any>) =>
  ['penyuluh', key] as const

const getAll = (
  params?: DtActionsAtom
): ServiceQueryOptionType<
  ServiceGetAllResponse<Array<PenyuluhListDataType>>
> => ({
  queryKey: QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<PenyuluhListDataType>>
      >(`kelembagaan/bpp/${params?.id_bpp}/penyuluh`, {
        params: {
          page: params?.page,
          per_page: params?.perPage || undefined
        }
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const penyuluh = {
  queryKey: [QUERY_KEY(undefined)[0]],
  getAll
}
